function getLevels<T>(obj: T, levels: string[] = []): string[] {
  if (!obj) {
    return [];
  }
  for (const k in obj) {
    if (obj[k] instanceof Object) {
      levels.push(k);
      getLevels(obj[k], levels);
    }
  }
  return levels;
}

export function getLeafNodeObj<T>(obj: T, leafKey: string): T[keyof T] | Record<string, unknown> | undefined {
  if (!obj) {
    return {};
  }
  const levels = getLevels(obj);

  let newObj;
  for (let i = 0, l = levels.length; i < l; i += 1) {
    const level = levels[i];
    if (level === leafKey) {
      return newObj;
    }
    newObj = newObj ? newObj[level as typeof newObj] : obj[level as keyof T];
  }
  return newObj;
}
